export default "__VITE_ASSET__7fe4e6a6__"